import React, { useState, useEffect } from 'react'
import {
  Table,
  Button,
  Input,
  Modal,
  Spin,
  Row,
  Col,
  Tooltip,
  Popconfirm,
} from 'antd';
import { CloseOutlined, EditOutlined, EyeOutlined, SearchOutlined } from '@ant-design/icons';
import apiRequest from '../../hooks/apiRequest';
import Layouts from '../../components/Layouts';
import UploadDocument from './UploadDocuments';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { toast } from 'react-toastify';

const Documents = () => {
  const [nationalID, setNationalID] = useState('');
  const [baseData, setBaseData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [documentId, setDocumentId] = useState(null);
  const [documentView, setDocumentView] = useState(null);
  const claimId = useParams();
  const claimNumber = useParams();
  const ProductId = useParams();
  const insurerId = useParams();

  useEffect(() => {
    fetchData()
    console.log('productId', baseData)
  }, [modalVisible])

  const fetchData = async () => {
    setLoading(true)
    try {
      const response = await apiRequest(
        process.env.REACT_APP_BASE_URL_DOCUMENT +
        `/Document/ByEntity/${claimId?.claimNumber}/0`,
      )
      setBaseData(response?.data?.data)
    } catch (error) {
      console.error('Error fetching insurers', error)
    } finally {
      setLoading(false)
    }
  }

  const handleSearch = () => {
    fetchData()
  }

  const handleCreateInsurer = () => {
    // const selectedProductId = '';
    // debugger;
    // localStorage.setItem('productId', selectedProductId);
    setDocumentId(null)
    setModalVisible(true)
  }

  const handleView = () => {
    setDocumentView(true)
  }
  const deleteDocument = async documentID => {
    const url =
      process.env.REACT_APP_BASE_URL_DOCUMENT + `/Document/${documentID}`

    try {
      setLoading(true)
      const response = await apiRequest(url, 'POST')
      if (response.success) {
        toast.success('Document deleted successfully')
        fetchData()
      } else {
        toast.error(response.error || 'Failed to delete document')
      }
    } catch (error) {
      toast.error('Something went wrong while deleting. Please try again.')
    } finally {
      setLoading(false)
    }
  }
  const columns = [
    {
      title: 'Name',
      dataIndex: 'documentName',
      key: 'name',
    },
    // { title: 'Email', dataIndex: 'email', key: 'email' },
    // { title: 'Phone', dataIndex: 'phone', key: 'phone' },
    {
  title: 'Actions',
  key: 'actions',
  render: (_, record) => (
    <>
      <Popconfirm
        title="Are you sure to delete?"
        onConfirm={() => deleteDocument(record?.id)}
      >
        <Tooltip title="Delete">
          <Button className="delete_btn" danger style={{ marginRight: '8px' }}>
            <CloseOutlined />
          </Button>
        </Tooltip>
      </Popconfirm>

      <Tooltip title="View Claim">
        <Button
          type="default"
          onClick={() => {
            if (!claimNumber?.claimNumber) {
              toast.warn('Claim number not found!')
              return
            }
            window.open(`/claims/${claimNumber.claimNumber}`, '_blank')
          }}
        >
          <EyeOutlined />
        </Button>
      </Tooltip>
    </>
  ),
}

  ]

  return (
    <Layouts title="Insurers" classname="dashboard">
      <div className="dash-bg-white">
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={24} md={24} lg={12}>
            <div className="section-top-heading">
              <h3
                style={{ color: '#0C1362', fontWeight: '600', fontSize: '20px' }}>
                Documents
              </h3>
            </div>
          </Col>
          <Col xs={24} sm={24} md={24} lg={7}>
            <div className="item-search">
              <Input.Search
                placeholder="Search ..."
                prefix={<SearchOutlined />}
                value={nationalID}
                onChange={e => setNationalID(e.target.value)}
              />
            </div>
          </Col>
          <Col xs={24} sm={24} md={3} lg={2}>
            <div className="create-quotation">
              <Button
                type="primary"
                onClick={handleSearch}
                style={{ marginLeft: 10 }}>
                Search
              </Button>
            </div>
          </Col>
          <Col xs={24} sm={24} md={3} lg={2}>
            <div className="create-quotation">
              <Button type="primary" onClick={handleCreateInsurer}>
                Upload Documents
              </Button>
            </div>
          </Col>
        </Row>
      </div>

      {loading ? (
        <Spin
          className="loader-icon-fixed"
          size="large"
          style={{ display: 'block', marginTop: 20 }}
        />
      ) : (
        <Table columns={columns} dataSource={baseData} rowKey="id" />
      )}
      <Modal
        title="Upload Document"
        centered
        visible={modalVisible}
        footer={null}
        onCancel={() => setModalVisible(false)}
        width={750}>
        <UploadDocument
          moduleId={103}
          documentId={documentId}
          claimId={claimId?.claimId}
          claimNumber={claimNumber?.claimNumber}
          insurerId={insurerId?.insurerId}
          ProductId={ProductId?.ProductId}
          onSucess={() => setModalVisible(false)}
          visible={modalVisible}
        />
      </Modal>
    </Layouts>
  )
}

export default Documents;
